<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :actions="actions"
      :title="title"
      :beforeSetupGrid="beforeSetupGrid"
      ref="grid"
      :selectionEnabled="false"
    ></dx-grid>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.title,
    };
  },
  data: () => ({
    url: "",
    title: "ManageEngine Priorities",
    actions: [],
    columns: [
      {
        label: "Id",
        field: "id",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Name",
        field: "name",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Text",
        field: "text",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Color",
        field: "color",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Deleted",
        field: "deleted",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  created() {
    this.actions.push({
      text: "Sync Priorities",
      action: this.syncPriorities,
    });
    this.actions.push({
      text: "Edit Priorities on ManageEngine",
      action: this.openManageEnginePriorities,
    });
  },
  methods: {
    async syncPriorities() {
      try {
        await this.$http.post(
          "api/ManageenginePriorities/SyncManageEnginePriorities"
        );
      } catch (error) {
        this.$notify({
          group: "notification",
          text: "Error syncing priorities",
          type: "error",
        });
        return;
      }
      this.$refs.grid.reloadGrid();
      this.$notify({
        group: "notification",
        text: "Priorities synced successfully",
        type: "success",
      });
    },
    async beforeSetupGrid() {
      this.url = "ManageenginePriorities";
    },
    openManageEnginePriorities() {
      window.open(
        "https://utaw.sdpondemand.manageengine.com/app/itdesk/AdminDetails.cc?forwardTo=priority",
        "_blank"
      );
    },
  },
};
</script>
